import type { ComponentProps } from "react"
import { cn } from "@/lib/utils.js"

/**
 * Tables carry most of what this panel exists to show, so they are set for
 * reading: 14px near-black body, rows tall enough to scan, a quiet uppercase
 * header — one of the two places uppercase is allowed. No shadow; the border
 * is the object.
 */
export function Table({ className, ...props }: ComponentProps<"table">) {
  return (
    <div className="overflow-x-auto rounded-lg border bg-card shadow-xs">
      <table className={cn("w-full border-collapse text-sm", className)} {...props} />
    </div>
  )
}

export function Th({ className, ...props }: ComponentProps<"th">) {
  return (
    <th
      className={cn(
        "h-9 border-b bg-muted/50 px-3.5 text-left align-middle text-[11.5px] font-medium uppercase tracking-[0.05em] text-muted-foreground first:rounded-tl-lg last:rounded-tr-lg",
        className,
      )}
      {...props}
    />
  )
}

/** Rows light up on hover: these tables are read by someone hunting one line. */
export function Tr({ className, ...props }: ComponentProps<"tr">) {
  return (
    <tr
      className={cn("border-b transition-colors last:border-0 hover:bg-muted/40", className)}
      {...props}
    />
  )
}

export function Td({ className, ...props }: ComponentProps<"td">) {
  return <td className={cn("px-3.5 py-2.5 align-middle", className)} {...props} />
}
